import { render } from "./VendorAddEditFormModal.vue?vue&type=template&id=0fc88a5c&lang=pug"
import script from "./VendorAddEditFormModal.vue?vue&type=script&lang=ts"
export * from "./VendorAddEditFormModal.vue?vue&type=script&lang=ts"

import "./VendorAddEditFormModal.vue?vue&type=style&index=0&id=0fc88a5c&lang=scss"
script.render = render

export default script